module.exports = __webpack_public_path__ + "img/symbol_8.1eabc1ae.png";